import { motion } from "framer-motion";
import { WEBHOOKS } from "../lib/webhooks";
import { useState } from "react";

const BASE_COSTS = { sd45: 10, sd5pro: 25, nano: 50 };

const packs = [
  { id: "starter", lookup_key: "credits_starter", label: "Starter", credits: 150,  price: "9,99 €",  bonus: 0,  featured: false },
  { id: "growth",  lookup_key: "credits_growth",  label: "Growth",  credits: 500,  price: "24,99 €", bonus: 25, featured: true  },
  { id: "pro",     lookup_key: "credits_pro",     label: "Pro",     credits: 1250, price: "49,99 €", bonus: 40, featured: false },
];

function packLines(credits) {
  return [
    { model: "SD 4.5", n: Math.floor(credits / BASE_COSTS.sd45) },
    { model: "SD 5 Pro", n: Math.floor(credits / BASE_COSTS.sd5pro) },
    { model: "Nano Banana Pro", n: Math.floor(credits / BASE_COSTS.nano) },
  ];
}

export function Precios({ user, onNeedAuth }) {
  const [busy, setBusy] = useState("");
  const [err, setErr] = useState("");

  const buy = async (pack) => {
    if (!user) return onNeedAuth?.();

    setBusy(pack.id);
    setErr("");

    try {

      const response = await fetch(WEBHOOKS.packs, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          lookup_key: pack.lookup_key,
          user_email: user.email,
          user_id: user.id,
        }),
      });

      const r = await response.json();

      if (r?.checkoutUrl) {

        window.location.href = r.checkoutUrl;

      } else if (r?.checkout_url) {

        window.location.href = r.checkout_url;

      } else {

        setErr("No se pudo iniciar el checkout.");
        setBusy("");

      }

    } catch (e) {

      console.error(e);
      setErr("Error de conexión con el checkout. Vuelve a intentarlo.");
      setBusy("");

    }
  };

  return (
    <section id="precios" className="relative px-5 md:px-8 py-24 md:py-32">
      <div className="max-w-[1500px] mx-auto">
        <div className="flex items-end justify-between mb-14 md:mb-16 gap-6 flex-wrap">
          <div>
            <span className="tag mb-4 inline-flex">§ 006 · Precios · Pago único</span>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
              className="font-display text-[8vw] md:text-[4.6vw] leading-[0.95] tracking-[-0.02em] font-light"
            >
              Créditos, <span className="italic font-serif text-[rgb(var(--brand))]">sin drama.</span>
            </motion.h2>
          </div>
          <p className="text-[rgb(var(--paper-dim))] max-w-sm text-sm">
            Sin suscripción. Los créditos no caducan. Cambia de motor cuando quieras.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {packs.map((p, i) => {
            const lines = packLines(p.credits);
            return (
              <motion.div
                key={p.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                onMouseMove={(e) => {
                  const r = e.currentTarget.getBoundingClientRect();
                  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
                  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
                }}
                className={`relative rounded-2xl p-7 md:p-8 card-tech overflow-visible ${
                  p.featured ? "!border-[rgb(var(--brand))]/50 glow-cyan" : ""
                }`}
                data-testid={`pack-${p.id}`}
              >
                {p.featured && (
                  <div className="absolute -top-3 left-6 font-mono text-[10px] uppercase tracking-widest bg-[rgb(var(--brand))] text-[rgb(var(--ink))] px-3 py-1 rounded-full">
                    Recomendado
                  </div>
                )}
                {p.bonus > 0 && (
                  <div className="absolute -top-3 right-6 font-mono text-[10px] uppercase tracking-widest border border-[rgb(var(--brand))]/40 text-[rgb(var(--brand))] bg-[rgb(var(--ink))] px-3 py-1 rounded-full" data-testid={`bonus-${p.id}`}>
                    +{p.bonus}% créditos / €
                  </div>
                )}

                <span className="tag">Pack · {p.label}</span>

                <div className="mt-6 flex items-baseline gap-3">
                  <div className="font-display font-light text-5xl md:text-6xl leading-none text-[rgb(var(--paper))]">
                    {p.price}
                  </div>
                  <div className="font-mono text-xs text-[rgb(var(--paper-dim))]">/pack</div>
                </div>
                <div className="mt-1 font-mono text-[10px] uppercase tracking-widest text-[rgb(var(--paper-dim))]/80">
                  IVA incluido
                </div>
                <div className="mt-2 font-display italic text-xl text-[rgb(var(--brand))]">
                  {p.credits.toLocaleString("es-ES")} créditos
                </div>

                <ul className="mt-6 space-y-2.5">
                  {lines.map((l) => (
                    <li key={l.model} className="flex items-center gap-3 text-sm text-[rgb(var(--paper-dim))]">
                      <span className="h-1 w-1 rounded-full bg-[rgb(var(--brand))]" />
                      <span>
                        <span className="text-[rgb(var(--paper))] font-medium font-mono">{l.n}</span>{" "}
                        imágenes en <span className="text-[rgb(var(--paper))]">{l.model}</span>
                      </span>
                    </li>
                  ))}
                </ul>
                <div className="mt-3 font-mono text-[10px] uppercase tracking-widest text-[rgb(var(--paper-dim))]/70">
                  Sobre resolución base · sin recargos
                </div>

                <button
                  onClick={() => buy(p)}
                  disabled={busy === p.id}
                  className={`mt-8 w-full rounded-full py-3 text-sm font-medium transition-colors ${
                    p.featured
                      ? "bg-[rgb(var(--brand))] text-[rgb(var(--ink))] hover:bg-[rgb(var(--paper))]"
                      : "bg-white/5 text-[rgb(var(--paper))] hover:bg-white/10 border border-white/10"
                  }`}
                  data-testid={`buy-${p.id}`}
                >
                  {busy === p.id ? "Redirigiendo…" : "Comprar créditos"}
                </button>
              </motion.div>
            );
          })}
        </div>
        {err && <p className="mt-6 text-xs text-red-400 font-mono" data-testid="precios-error">{err}</p>}
      </div>
    </section>
  );
}
